import { useEffect } from "react";
import BillTable from "../../components/billTable/billTable";
import CostCard from "../../components/costCard/costCard";
import "./costBreakDown.css";
import { useDispatch, useSelector } from "react-redux";
import {
  resetOrderDetails,
  saveOrder,
} from "../../redux/reducers/costBreakdown";
import Loader from "../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import objectToArray from "../../utils/objectToArray";
import { usd } from "../../utils/convertToDollerFormat";
import { clearOrderPrice } from "../../redux/reducers/resellerAgentDashboard";
import { ReactComponent as BackBtn } from "../../assets/icons/arrow-down.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/info-icon.svg";

export default function CostBreakdown() {
  const { error, loading, orderDetails } = useSelector(
    (state) => state.costBreakdown
  );
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const customer_details = localStorage.getItem("customer_details");
  const plan_details = localStorage.getItem("configOptPlan");
  const hasImei = JSON.parse(plan_details)?.some(
    (item) => "imei" in item && item.imei
  );
  let details = JSON.parse(customer_details);

  const handleSubmit = () => {
    details &&
      dispatch(
        saveOrder({
          customerData: details.customerData,
          orderDetails: details.orderDetails,
        })
      );
    localStorage.removeItem("formData");
    localStorage.removeItem("configOptPlan");
  };

  useEffect(() => {
    if (orderDetails && orderDetails?.customerData && orderDetails?.orderData) {
      localStorage.removeItem("customer_details");
      sessionStorage.setItem("email_sent", true);
      dispatch(resetOrderDetails());
      dispatch(clearOrderPrice());
      navigate("/reseller-agent-dashboard");
    }
  }, [orderDetails]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleBack = () => {
    navigate("/reseller-agent-dashboard");
  };

  return (
    <>
      <Loader loading={!userData || loading} />
      <div className="cost-breakdown">
        <div className="previous-page" onClick={handleBack}>
          <BackBtn className="back-btn" />
          <p>Back</p>
        </div>
        <div className="header">
          <CostCard
            category="Monthly"
            price={usd(details?.orderPrice?.grand_total?.monthly_payment)}
            note="Estimated pricing includes taxes."
          />
          <CostCard
            category="Due Today"
            price={usd(details?.orderPrice?.grand_total?.instant_pay)}
            note="Includes taxes."
          />
        </div>
        <div className="full-cost-breakdown">
          <h1>Full Cost Breakdown Summary</h1>
          {details?.orderPrice?.orderDetails?.map((bill, i) => (
            <BillTable key={i} count={i + 1} body={objectToArray(bill)} />
          ))}
        </div>
        <div className="full-cost-breakdown total-amount">
          {details?.orderPrice && (
            <BillTable count={0} body={details.orderPrice} />
          )}
        </div>
        <p className="notes">
          The costs provided are approximate estimates, and the final price may
          be subject to change.
        </p>
        {hasImei && (
          <div className="notes byod-note">
            <InfoIcon className="byod-info" />
            <p className="">
              When a BYOD (Bring Your Own Device) phone with device protection
              is added, we are unable provide an exact price at the time of
              order submission. The order entry team must determine if the phone
              is compatible with our network and assess the value of the device
              at that time. The order confirmation from Optimum will include all
              the pricing associated with their purchase.
            </p>
          </div>
        )}
        <button className="proceed-btn" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </>
  );
}
